module.exports = __webpack_public_path__ + "static/media/video-origami.5314ebb8.png";